import React, { useEffect, useState } from 'react';
import { Alert, Button, Card, Col, Container, Form, Pagination, Row, Spinner, Table } from 'react-bootstrap';

import AdminSidebar from '../../Dashboard/AdminComponent/AdminSidebar';
import Header from '../../Dashboard/AdminComponent/Header';
import Footer from '../../Dashboard/AdminComponent/Footer';
import { fetchAdminAsplProducts, updateAdminAsplProduct } from '../api';

const AsplAdminPage = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [savingId, setSavingId] = useState('');
  const [message, setMessage] = useState('');
  const [query, setQuery] = useState('');
  const [searchInput, setSearchInput] = useState('');

  const [items, setItems] = useState([]);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);

  const loadProducts = async (targetPage = 1, targetQuery = query) => {
    setLoading(true);
    setMessage('');
    try {
      const res = await fetchAdminAsplProducts(targetQuery, targetPage, 20);
      setItems(res.data.results || []);
      setPage(res.data.page || 1);
      setPages(res.data.pages || 1);
    } catch (err) {
      setMessage('Failed to load ASPL products.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadProducts(1, query);
  }, [query]);

  const handleFieldChange = (asplId, key, value) => {
    setItems((prev) =>
      prev.map((item) =>
        item.aspl_id === asplId ? { ...item, [key]: value } : item
      )
    );
  };

  const handleSave = async (item) => {
    setSavingId(item.aspl_id);
    setMessage('');

    try {
      const payload = {
        name: item.name,
        brand: item.brand,
        category: item.category,
        stock: item.stock,
        price: item.price,
        is_active: item.is_active,
      };

      const res = await updateAdminAsplProduct(item.aspl_id, payload);
      const updated = res.data?.product;
      if (updated) {
        setItems((prev) => prev.map((row) => (row.aspl_id === updated.aspl_id ? { ...row, ...updated } : row)));
      }
      setMessage(`Saved ${item.aspl_id} successfully.`);
    } catch (err) {
      setMessage(`Failed to save ${item.aspl_id}.`);
    } finally {
      setSavingId('');
    }
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    setQuery(searchInput.trim());
  };

  return (
    <div className="d-flex" style={{ minHeight: '100vh' }}>
      <AdminSidebar collapsed={collapsed} toggleSidebar={() => setCollapsed(!collapsed)} />
      <div style={{ marginLeft: collapsed ? '60px' : '200px', width: '100%', transition: 'margin-left 0.3s' }}>
        <Header />
        <Container fluid className="py-3">
          <Card className="shadow-sm border-0">
            <Card.Body>
              <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
                <h4 className="mb-0">ASPL Product Management</h4>
                <Form onSubmit={handleSearchSubmit} className="d-flex gap-2">
                  <Form.Control
                    value={searchInput}
                    onChange={(e) => setSearchInput(e.target.value)}
                    placeholder="Search by ASPL ID / reference / name"
                  />
                  <Button type="submit">Search</Button>
                </Form>
              </div>

              {message && <Alert variant="info" className="py-2">{message}</Alert>}

              {loading ? (
                <div className="text-center py-4"><Spinner animation="border" /></div>
              ) : (
                <Table responsive bordered hover>
                  <thead>
                    <tr>
                      <th>ASPL ID</th>
                      <th>Reference</th>
                      <th>Name</th>
                      <th>Brand</th>
                      <th>Category</th>
                      <th>USD Price</th>
                      <th>NGN Price</th>
                      <th>Stock</th>
                      <th>Active</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {items.map((item) => (
                      <tr key={item.aspl_id}>
                        <td>{item.aspl_id}</td>
                        <td>{item.reference}</td>
                        <td><Form.Control value={item.name || ''} onChange={(e) => handleFieldChange(item.aspl_id, 'name', e.target.value)} /></td>
                        <td><Form.Control value={item.brand || ''} onChange={(e) => handleFieldChange(item.aspl_id, 'brand', e.target.value)} /></td>
                        <td><Form.Control value={item.category || ''} onChange={(e) => handleFieldChange(item.aspl_id, 'category', e.target.value)} /></td>
                        <td><Form.Control type="number" step="0.01" value={item.price ?? ''} onChange={(e) => handleFieldChange(item.aspl_id, 'price', e.target.value)} /></td>
                        <td>₦{item.price_ngn ? Number(item.price_ngn).toLocaleString('en-NG') : '-'}</td>
                        <td><Form.Control type="number" value={item.stock ?? ''} onChange={(e) => handleFieldChange(item.aspl_id, 'stock', e.target.value)} /></td>
                        <td>
                          <Form.Check
                            type="switch"
                            checked={!!item.is_active}
                            onChange={(e) => handleFieldChange(item.aspl_id, 'is_active', e.target.checked)}
                          />
                        </td>
                        <td>
                          <Button size="sm" onClick={() => handleSave(item)} disabled={savingId === item.aspl_id}>
                            {savingId === item.aspl_id ? 'Saving...' : 'Save'}
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              )}

              <Row>
                <Col>
                  <Pagination>
                    <Pagination.Prev disabled={page <= 1} onClick={() => loadProducts(page - 1, query)} />
                    <Pagination.Item active>{page}</Pagination.Item>
                    <Pagination.Next disabled={page >= pages} onClick={() => loadProducts(page + 1, query)} />
                  </Pagination>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Container>
        <Footer />
      </div>
    </div>
  );
};

export default AsplAdminPage;
